(function($) {

    $(document).on( 'click', '#lang-menu-toggler', function() {
        $('#lang-menu').addClass('show');
    });

})
(jQuery);
